import React, { useEffect, useState } from 'react'
import store from '../../../store';
import { connect } from "react-redux";
import Alert from './Alert';
import { countdown, stopTimer } from './helper';
import Button from './input/Button'
import Input from './input/Input'
import { apiUrl } from './constants';
import { GetRequest } from './helper';
import { ExIcon, OtpTimer } from './svg';
import Calendar from './calendar';
import moment from 'moment';
import AccountLoader from '../../manageAccount/accountLoader';
import { updatePnrEnqiryData, updatePnrEnqiryTripData } from '../../../actions/search-actions';
import Bookingcard from './bookingcard';
import { EMAIL_ID, EMAIL_ID_ERR, t } from '../../../translations/pnrEnquiry/GuestEmail';
import { OTP, OTP_RESEND_MSZ, OTP_RESEND_OPT, RECENT_BOOKING, RESEND, SEND_OTP, tPnrCommon } from '../../../translations/pnrEnquiry/Common';
import { SEARCH,LOCKOTP_MSG, tCommon } from '../../../translations/Common';

const GuestEmail = (props) => {
    const { setCardData } = props
    const propdata = store.getState();
    const pnrEnquiryData = propdata.search.pnrEnquiryData;
    const [user, setUser] = useState({ email: '', otp: '', obRef: '', bookingDate: '' });
    const [loader, setLoader] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otpVal, setOtpVal] = useState(0);
    const [resend, setResend] = useState("");
    const [alert, setAlert] = useState({ show: false, msg: '' });
    const [selDate, setSelDate] = useState(new Date());
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    const [bookingData, setBookingData] = useState(false)

    const handleChange = (val, param) => {
        user[param] = val;
        setUser({ ...user });
    }
    const handleAlert = (msg = false) => {
        if (msg) {
            setAlert({ show: true, msg });
        } else {
            setAlert({ show: false, msg: '' })
        }
    }

    const sendOtpEmail = (otp) => {
        if (otp) {
            setLoader(true);
            const url = `${apiUrl.sendOtpEmail}?emailId=${user.email}&otp=${otp}`;
            GetRequest(url).then(res => {
                if (res.success) {
                    // console.log('Email sent');
                }
                setLoader(false);
            })
        } else {
            setAlert({ show: true, msg: 'Something went wrong...' })
        }
    }

    const generateOtp = () => {
        const email = user.email;
        if (email && emailRegex.test(email)) {
            setLoader(true);
            // setTimeout(() => {
            //   setLoader(false);
            //   setOtpSent(true);
            //   setResend("disable")
            //   countdown('emailClock', 3, 0, setResend);
            // }, 2000)
            const url = `${apiUrl.sendOtpEmail}?email=${email}`;
            GetRequest(url).then(res => {
                if (res.Success) {
                    // setOtpVal(res.otp);
                    // sendOtpEmail(res.otp);
                    setOtpSent(true);
                    setResend("disable")
                    countdown('emailClock', 3, 0, setResend);
                }
                setLoader(false);
            })
        } else {
            setAlert({ show: true, msg: 'Please enter valid Email Id' })
        }
        user.otp = '';
        setUser({ ...user });
    }


    const getStatusData = () => {
        const email = user.email;
        const obRef = user.obRef;
        setLoader(true);
        let url = `${apiUrl.statusDetails}?searchVal=${email}&mode=E&obRef=`;
        GetRequest(url).then(result => {
            setLoader(false);
            // result = resp;
            if (result.IsSuccess) {
                let res = result.Data;
                setBookingData(res);
                store.dispatch(updatePnrEnqiryData(res));
                store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
            } else {
                setBookingData(false);
                store.dispatch(updatePnrEnqiryData(false));
                store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
            }
        }).catch((err) => {
            console.log("err", err);
            setLoader(false);
        })
    }


    const verify = () => {
        // if (otpVal === user.otp) {
        //     const email = user.email;
        //     const obRef = user.obRef;
        //     setLoader(true);
        //     stopTimer();
        //     let url = `${apiUrl.statusDetails}?searchVal=${email}&mode=E&obRef=`;
        //     GetRequest(url).then(result => {
        //         setLoader(false);
        //         // result = resp;
        //         if (result.IsSuccess) {
        //             let res = result.Data;
        //             setBookingData(res);
        //             store.dispatch(updatePnrEnqiryData(res));
        //             store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
        //         } else {
        //             setBookingData(false);
        //             store.dispatch(updatePnrEnqiryData(false));
        //             store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
        //         }
        //     }).catch((err) => {
        //         console.log("err", err);
        //         setLoader(false);
        //     })
        // } else {
        //     setAlert({ show: true, msg: 'Please enter valid OTP' })
        // }

        const url = `${apiUrl.validateOtpEmail}?email=${user.email}&OTP=${user.otp}`;
        if (user.otp) {
            setLoader(true);
            stopTimer();
            GetRequest(url).then(res => {
                setLoader(false);
                if (res.Success) {
                    getStatusData()
                } else {
                    setAlert({ show: true, msg:  res?.IsLocked ? tCommon(LOCKOTP_MSG): 'Please enter valid OTP' })
                }
            }).catch((err) => {
                console.log("err", err);
                setLoader(false);
            })
        } else {
            setAlert({ show: true, msg: 'Please enter OTP' })
        }

    }

    const getParseData = (data) => {
        let rs = [];
        data.forEach(el => {
            let resp = {};
            if (el.pnrNo || el.OldFormatPNR) {
                resp.JourneyDate = el.JourneyDate;
                resp.TripCode = el.TripCode;
                resp.BusType = el.BusDetails[0].BusType;
                resp.ArrivalTime = el.BusDetails[0].DropoffTime;
                resp.BookingDateTime = el.BookingTime;
                resp.BookingRefNo = el.BookingStatus === 'Payment Pending' ? "" : el.pnrNo;
                resp.DepartureTime = el.BusDetails[0].PickupTime;
                resp.DropoffID = el.BusDetails[0].DropoffID;
                resp.DroppoffName = el.BusDetails[0].DropOffName;
                resp.FromCityName = el.BusDetails[0].FromCity;
                resp.ToCityName = el.BusDetails[0].ToCity;
                resp.FromCityID = el.BusDetails[0].FromCityID;
                resp.ToCityID = el.BusDetails[0].ToCityID;
                resp.PickupID = el.BusDetails[0].PickupID;
                resp.PickupName = el.BusDetails[0].PickupName;
                resp.RouteCode = el.RouteCode;

                // resp.PNR = el.OldFormatPNR;
                //resp.BookingStatus = el.BookingStatus === 'Booking' ? "B" : "C";

                resp.PNR = el.BookingStatus === 'Payment Pending' ? "" : el.OldFormatPNR;
                resp.mobile = el.MobileNo;
                resp.BookingStatus = ((el.BookingStatus === 'Payment Pending' || el.BookingStatus === 'PDBF' || el.BookingStatus === 'NA') ? el.BookingStatus : el.BookingStatus === 'Booking' ? "B" : "C");

                resp.IsLinkBooking = el.IsLinkBooking;
                resp.showCancel = false;
                resp.showEdit = false;
                resp.viewBokking = false;
            }
            rs.push(resp);
        });
        return rs;
    }

    return (
        <>
            {loader && <AccountLoader />}
            {!pnrEnquiryData && <div className='bookingStatus-email'>
                <div className="email_container">
                    <div className='firstInput' style={{ width: '70%' }}>
                        <Input type="text" label={t(EMAIL_ID)} value={user.email} validation={'email'} errMsg={t(EMAIL_ID_ERR)} autoFocus={true} onChange={(e) => { handleChange(e, 'email') }} />
                    </div>
                    <div className="sendOTP-button">
                        {
                            otpSent ?
                                <Button text={tPnrCommon(RESEND)} className={`button ${resend !== "disable" && resend !== "" ? `active` : `disable`}`} extraStyle={{ "height": "48px" }} onClick={() => (resend !== "disable" && resend !== "") && generateOtp()} />
                                :
                                <Button text={tPnrCommon(SEND_OTP)} className={`button active`} extraStyle={{ "height": "48px" }} onClick={generateOtp} />
                        }
                    </div>
                    <div className='secInput'>
                        <Input disabled={otpSent ? false : true} type='tel' label={tPnrCommon(OTP)} value={user.otp} validation={'otp'} max='4' onChange={(val) => { handleChange(val, 'otp') }} errMsg={""}/>
                    </div>
                    <div className="verify-button">

                        <Button text={tCommon(SEARCH)} className={`button ${String(user.otp).length === 4 ? `active` : `disable`}`} extraStyle={{ "height": "48px" }} onClick={() => verify()} />

                    </div>
                </div>
                <div className="bookingStatus-Emailmessage">
                    <div className="message" style={{ display: 'flex', marginTop: '6px' }}>

                        {
                            resend === "" ?
                                ""// <span>Enter One Time Password (OTP) sent on to your Email ID</span> 
                                :
                                resend === "Resend" ? <span>{tPnrCommon(OTP_RESEND_MSZ)}</span> :
                                    <><span style={{ marginRight: '8px', marginTop: '-2px' }}><ExIcon /></span><span>{tPnrCommon(OTP_RESEND_OPT)}</span> <span id="emailClock" style={{ color: "red", marginLeft: '4px' }}></span></>
                        }
                    </div>
                </div>
            </div>
            }
            {
                pnrEnquiryData && pnrEnquiryData.length > 0 &&
                <div className='booking-cards'>
                    <Bookingcard cardData={getParseData(pnrEnquiryData)} mobile={user.mobile} />
                </div>
            }
            {
                pnrEnquiryData && pnrEnquiryData.length === 0 &&
                <div className='booking-cards'>
                    <div style={{ fontSize: '16px', fontWeight: '500', textAlign: 'center' }}>{tPnrCommon(RECENT_BOOKING)}</div>
                </div>
            }
            {
                alert.show &&
                <Alert msg={alert.msg} error={true} close={() => handleAlert()} />
            }
        </>

    )
}

const mapStateToProps = function (store) {
    return store;
};
export default connect(mapStateToProps)(GuestEmail);